<form
  [formGroup]="messageForm"
  (submit)="sendMessage()"
  class="chat-page-input">
  <!-- text box icon -->
  <div class="chat-page-input__mail-icon-container">
    <i class="iconsax" icon-name="mail-edit"></i>
  </div>

  <!-- text box field -->
  <div
    [class.message-input_text-field--edit-mod]="false"
    [attr.placeholder]="'home.write_your_message_here' | translate"
    class="chat-page-input__field no-scrollbar"
    type="text"
    icon="mail-edit"
    iconPosition="left"
    variant="default"
    [contentEditable]="true"
    (input)="onTypeMessage(messageBox)"
    #messageBox></div>

  <!-- options -->
  <button class="chat-page-input__send-btn" type="submit">
    <i class="send-btn-icon iconsax" icon-name="send-2"></i>
  </button>
</form>
